document.addEventListener('DOMContentLoaded', function() {
    // 必要な要素が存在しない場合は処理を終了
    const prefectureSelectElement = document.getElementById('prefecture-select');
    if (!prefectureSelectElement) {
        return;
    }

    const colorCount = 10; // 利用可能な色の数
    const itemColorMap = new Map(); // 各アイテムの色を記憶
    let isUpdating = false; // 更新中フラグ

    const prefectureSelect = new TomSelect('#prefecture-select', {
        plugins: ['remove_button', 'clear_button'],
        maxItems: null,
        placeholder: '都道府県を選択',
        loadThrottle: 300, // 検索のスロットリング
        closeAfterSelect: false, // 選択後もドロップダウンを開いたまま
        render: {
            item: function(data, escape) {
                // アイテムに色が割り当てられていない場合は新しい色を割り当て
                if (!itemColorMap.has(data.value)) {
                    const currentSize = itemColorMap.size;
                    itemColorMap.set(data.value, currentSize % colorCount);
                }
                const colorIndex = itemColorMap.get(data.value);
                return '<div class="ts-item-color-' + colorIndex + '">' + escape(data.text) + '</div>';
            },
            option: function(data, escape) {
                // オプションの表示をカスタマイズ
                return '<div>' + escape(data.text) + '</div>';
            }
        },
        onItemAdd: function(value) {
            // アイテム追加時に色を割り当て
            if (!itemColorMap.has(value)) {
                const currentSize = itemColorMap.size;
                itemColorMap.set(value, currentSize % colorCount);
            }
            // 検索入力をクリア
            this.setTextboxValue('');
            this.refreshOptions();
        },
        onItemRemove: function(value) {
            if (isUpdating) return;

            // アイテムが削除されたら色の割り当てを削除
            itemColorMap.delete(value);

            // 色の再割り当ては行わない（パフォーマンス向上のため）
            // 必要に応じて、残りのアイテムの色はそのまま保持
        },
        onDropdownOpen: function() {
            // ドロップダウンを開いた時の処理
            this.clearActiveOption();
        },
        shouldLoad: function() {
            // 検索を無効化（全アイテムが常に表示される）
            return false;
        }
    });

    // 全選択ボタン
    document.getElementById('select-all').addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();

        // 既に処理中の場合は何もしない
        if (isUpdating) return;

        isUpdating = true;

        // 一度にすべてを設定
        const select = document.getElementById('prefecture-select');
        const options = Array.from(select.options).map(option => option.value);

        // 色をリセット
        itemColorMap.clear();

        // 一度にセット
        prefectureSelect.setValue(options);

        setTimeout(() => {
            isUpdating = false;
        }, 300);
    });

    // クリアボタン
    document.getElementById('clear-all').addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();

        // 既に処理中の場合は何もしない
        if (isUpdating) return;

        isUpdating = true;
        itemColorMap.clear();
        prefectureSelect.clear();

        setTimeout(() => {
            isUpdating = false;
        }, 300);
    });

    // キーボードショートカットを無効化（Ctrl+A, Cmd+Aなど）
    document.getElementById('prefecture-select').addEventListener('keydown', function(e) {
        if ((e.ctrlKey || e.metaKey) && e.key === 'a') {
            e.preventDefault();
            e.stopPropagation();
            return false;
        }
    });
});
